export interface PM_V2_Template_Interface {
  id: number;
  Previous_PM_V2_Template_ID: number | null;
  PM_Code: string;
  PM_Title: string;
  Description: string;
  Version: number | null;
  Status: boolean | null;
  Time_Estimated: number | null;
  Default_Frequency: number | null;
  Default_Warning_Days: number | null;
  Date_Created: string | null;
  Created_By: number | null;
  Count_Item?: number;
}

export interface PM_V2_Template_Item_Interface {
  id: number;
  PM_V2_Template_ID: number | null;
  Order_Item: number | null;
  Title_Item: string;
  Type_Item: string;
  Required_Is: boolean | null;
  Criteria_Acceptance: string;
  Instruction: string;
  Value_Frequency: number | null;
  Days_Warning: number | null;
  Active: boolean | null;
}

export interface PM_V2_Template_Detail_Interface {
  model: PM_V2_Template_Interface;
  items: PM_V2_Template_Item_Interface[];
}

export interface PM_V2_Template_Save_Interface {
  model: PM_V2_Template_Interface;
  items: PM_V2_Template_Item_Interface[];
}

export interface PM_V2_Assignment_Interface {
  id: number;
  PM_V2_Template_ID: number | null;
  DeviceBehfa_ID: number | null;
  Active: boolean | null;

  PM_Code?: string;
  PM_Title?: string;
  Version?: number | null;
  Template_Status?: boolean | null;

  codeBEHFA?: string;
  description?: string;
  manufacturer?: string;
  model?: string;
  group_id?: number | null;
  GroupTitle?: string;
}

export interface PM_V2_Assignment_Item_Interface {
  id: number;
  PM_V2_Assignment_ID: number | null;
  PM_V2_Template_Item_ID: number | null;
  Date_Start: string | null;
  Last_PM_Date: string | null;
  Next_PM_Date: string | null;
  Active: boolean | null;

  Order_Item?: number | null;
  Title_Item?: string;
  Type_Item?: string;
  Required_Is?: boolean | null;
  Criteria_Acceptance?: string;
  Instruction?: string;
  Value_Frequency?: number | null;
  Days_Warning?: number | null;
  Template_Item_Active?: boolean | null;
  PM_Status?: string;
}

export interface PM_V2_Assignment_Detail_Interface {
  model: PM_V2_Assignment_Interface;
  items: PM_V2_Assignment_Item_Interface[];
}

export interface PM_V2_Assignment_Save_Interface {
  PM_V2_Template_ID: number;
  DeviceBehfa_IDs: number[];
  Date_Start: string | null;
}

export interface PM_V2_Assignment_Batch_Result_Interface {
  CreatedCount: number;
  SkippedDuplicateCount: number;
}

export interface PM_V2_Due_Interface {
  Assignment_ID: number;
  Assignment_Item_ID: number;
  Assignment_Active: boolean;
  Assignment_Item_Active: boolean;
  DeviceBehfa_ID: number | null;

  codeBEHFA: string;
  description: string;
  manufacturer: string;
  model: string;
  group_id: number | null;
  Group: string;
  SubGroup: string;

  PM_V2_Template_ID: number;
  PM_Code: string;
  PM_Title: string;
  Version: number | null;
  Template_Description: string;
  Time_Estimated: number | null;
  Template_Status: boolean | null;

  Template_Item_ID: number;
  Order_Item: number | null;
  Title_Item: string;
  Type_Item: string;
  Required_Is: boolean | null;
  Criteria_Acceptance: string;
  Instruction: string;
  Value_Frequency: number | null;
  Days_Warning: number | null;
  Template_Item_Active: boolean | null;

  Date_Start: string | null;
  Last_PM_Date: string | null;
  Next_PM_Date: string | null;
  Date_Start_Persian: string;
  Last_PM_Date_Persian: string | null;
  Next_PM_Date_Persian: string | null;
  Is_Never_Executed: boolean;
  Due_Status: string;
  Days_Overdue: number;
  Remaining_Days: number;
  Execution_Count: number;
  Last_Execution_Date: string | null;
  Last_Execution_Date_Persian: string | null;
  Last_Result: string | null;
  Last_Numeric_Value: number | null;
  Last_Text_Value: string | null;
  Last_Comment: string | null;
  Last_Performed_By: number | null;
  Last_Approved_By: number | null;
}

export interface PM_V2_Due_Equipment_Interface {
  Equipment_ID: number;
  Equipment_Name: string;
  Equipment_Code: string;
  Equipment_Model: string;
  Group: string | null;
  SubGroup: string | null;
  Template_ID: number;
  Template_Code: string;
  Template_Name: string;
  Assignment_ID: number;
  Due_Item_Count: number;
}

export interface PM_V2_Due_Equipment_Filter_Interface {
  TemplateTitle: string;
  Active: boolean;
  GroupId: number;
  SubGroupId: number;
  Keyword: string;
  DueWindow: string;
}

export interface PM_V2_Due_Equipment_Item_Interface {
  Equipment_ID: number;
  Equipment_Name: string;
  Equipment_Code: string;
  Equipment_Model: string;
  Template_ID: number;
  Template_Code: string;
  Template_Name: string;
  Assignment_Item_ID: number;
  Activity_Name: string;
  Frequency: number | null;
  Last_PM_Date: string | null;
  Next_PM_Date: string | null;
  Last_PM_Date_Persian: string | null;
  Next_PM_Date_Persian: string | null;
  Is_Never_Executed: boolean;
  Can_Execute: boolean;
}

export interface PM_V2_Due_Execution_History_Interface {
  Execution_ID: number;
  Activity_Name: string;
  Date_Due: string | null;
  Date_Due_Persian: string | null;
  Date_Execution: string | null;
  Date_Execution_Persian: string | null;
  Result: string;
  Numeric_Value: number | null;
  Text_Value: string | null;
  Description: string | null;
  Performer_Name: string;
}

export interface PM_V2_Execution_Interface {
  id: number;
  PM_V2_Assignment_Item_ID: number | null;
  Date_Due: string | null;
  Date_Execution: string | null;
  Result: string;
  Numeric_Value: number | null;
  Text_Value: string;
  Comment: string;
  Performed_By: number | null;
  Approved_By: number | null;
  Date_Execution_Persian?: string | null;

  Assignment_ID?: number;
  DeviceBehfa_ID?: number | null;
  codeBEHFA?: string;
  description?: string;
  manufacturer?: string;
  model?: string;
  PM_Code?: string;
  PM_Title?: string;
  Version?: number | null;
  Template_Item_ID?: number;
  Title_Item?: string;
  Type_Item?: string;
  Required_Is?: boolean | null;
}

export interface PM_V2_Execution_Save_Interface {
  model: PM_V2_Execution_Interface;
  Date_Execution_Persian: string | null;
}

export interface PM_V2_Execution_Context_Interface {
  Equipment_ID: number;
  Equipment_Code: string;
  Equipment_Name: string;
  Template_ID: number;
  Template_Code: string;
  Template_Name: string;
  Description: string;
  AcceptanceCriteria: string;
  Instruction: string;
  Activity_Name: string;
  Frequency: number | null;
  Assignment_Item_ID: number;
  Type_Item: string;
  Date_Due: string | null;
  PM_Title?: string;
  codeBEHFA?: string;
}

export interface PM_V2_Execution_History_Interface {
  context: PM_V2_Execution_Context_Interface;
  items: PM_V2_Execution_Interface[];
}

export interface PM_V2_Execution_Approve_Interface {
  id: number;
  Approved_By: number | null;
}

export interface PM_V2_Device_Interface {
  id: number;
  codeBEHFA: string;
  description: string;
  manufacturer: string;
  model: string;
}

export function PM_V2_EmptyTemplate(): PM_V2_Template_Interface {
  return {
    id: 0,
    Previous_PM_V2_Template_ID: null,
    PM_Code: '',
    PM_Title: '',
    Description: '',
    Version: 1,
    Status: true,
    Time_Estimated: null,
    Default_Frequency: null,
    Default_Warning_Days: null,
    Date_Created: null,
    Created_By: null
  };
}

export function PM_V2_EmptyTemplateItem(order: number = 1): PM_V2_Template_Item_Interface {
  return {
    id: 0,
    PM_V2_Template_ID: null,
    Order_Item: order,
    Title_Item: '',
    Type_Item: 'CHECK',
    Required_Is: true,
    Criteria_Acceptance: '',
    Instruction: '',
    Value_Frequency: null,
    Days_Warning: null,
    Active: true
  };
}

export function PM_V2_EmptyAssignment(): PM_V2_Assignment_Interface {
  return {
    id: 0,
    PM_V2_Template_ID: null,
    DeviceBehfa_ID: null,
    Active: true
  };
}

export function PM_V2_EmptyExecution(): PM_V2_Execution_Interface {
  return {
    id: 0,
    PM_V2_Assignment_Item_ID: null,
    Date_Due: null,
    Date_Execution: null,
    Result: '',
    Numeric_Value: null,
    Text_Value: '',
    Comment: '',
    Performed_By: null,
    Approved_By: null
  };
}
